import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.community.view');
import { OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-community-view',
template: templateSource || '',
    styles: [``],
})
export class PortalCommunityViewComponent implements OnInit {

    @Input() category!: string;
    @Input() postId!: string;

    public user: any = null;
    public post: any = {};
    public comments: any[] = [];
    public loading = false;
    public content = '';

    constructor(@Inject( Router)         private router: Router,@Inject( Service    )         public service: Service    ) {}

    get title(): string {
        const map: any = {
            notice: '공지사항',
            faq: '문의사항'
        };
        return map[this.post?.category] || '게시판';
    }

    get canReply(): boolean {
        if (!this.user) return false;
        if (this.post?.parent_id && this.post.parent_id !== 0) return false;
        if (this.post?.priority === 1) return false;
        if (this.category === 'notice') return this.user.role === 'admin';
        if (this.category === 'faq') return true;
        return false;
    }

    async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    async load() {

        if (!this.postId) return;

        this.loading = true;

        const res = await wiz.call('list', {
            post_id: this.postId
        });

        if (res?.code === 200 && res?.data) {

            this.post = res.data.post || {};
            this.user = res.data.user || null;

            if (typeof this.post.files === 'string') {
                try {
                    this.post.files = JSON.parse(this.post.files);
                } catch {
                    this.post.files = [];
                }
            }

            this.comments = Array.isArray(res.data.comments)
                ? res.data.comments.map((c: any) => ({
                    ...c,
                    edit: false
                }))
                : [];
        }

        this.loading = false;
    }

    goList() {
        this.router.navigate(['/community', this.post.category, 'list']);
    }

    edit() {
        this.router.navigate(['/community', this.post.category, 'edit', this.post.id]);
    }

    reply() {
        this.router.navigate(['/community', this.post.category, 'edit', 'new', this.post.id]);
    }

    async addComment() {

        if (!this.content.trim()) return;

        const res = await wiz.call('comment', {
            post_id: this.postId,
            content: this.content.trim()
        });

        if (res?.code === 200) {

            this.content = '';

            await this.load();
            await this.service.render();
        }
    }

    async deleteComment(comment) {

        const res = await wiz.call('delete', { id: comment.id });

        if (res?.code === 200) {
            await this.load();  
            await this.service.render(); 
        }
    }

    async editComment(comment) {
        comment.edit = true;
        this.comments = [...this.comments];
        await this.service.render();
    }

    async cancelEdit(comment) {
        comment.edit = false;
        this.comments = [...this.comments];
        await this.service.render();
    }

    async updateComment(comment) {

        if (!comment.content?.trim()) return;

        const res = await wiz.call('update', {
            id: comment.id,
            content: comment.content.trim()
        });

        if (res?.code === 200) {
            await this.load();
            await this.service.render();
        }
    }
}

export default PortalCommunityViewComponent;